class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.currentTarget.dataset.popup; // Alwan: the button, not the icon or label inside it
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

// Alwan: the discount code (cart drawer popup and cart page). The code goes through the cart API, so a wrong code is
// reported under the field without closing the popup, reloading the page or drawing the cart again; a valid code
// draws the cart once with its saving. The cart page's field sits in the cart form: Enter applies, never submits.
class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('[data-update-coupon]');
    const stored = localStorage.getItem('storedDiscount');
    if (stored && !this.input.value) this.input.value = stored;
    this.button?.addEventListener('click', (event) => {
      event.preventDefault();
      this.apply();
    });
    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.apply();
    });
    this.input.addEventListener('input', () => this.setError(''));
  }

  async update(discount) {
    const response = await fetch(`${routes.cart_update_url}.js`, {...fetchConfig(), body: JSON.stringify({discount})});
    if (!response.ok) throw new Error(response.status);
    return response.json();
  }

  async apply() {
    const code = this.input.value.trim();
    if (this.button?.classList.contains('is-loading')) return;
    this.button?.classList.add('is-loading');
    this.button?.setAttribute('aria-busy', 'true');
    try {
      const before = await (await fetch(`${routes.cart}.js`)).json();
      const kept = (before.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code);
      let cart = await this.update([...kept, code].filter(Boolean).join(','));
      const entry = (cart.discount_codes || []).find((item) => item.code.toLowerCase() === code.toLowerCase());
      if (code && (!entry || !entry.applicable)) {
        // Shopify keeps a code that does not apply on the cart; take it off again and say so here.
        cart = await this.update(kept.join(','));
        localStorage.removeItem('storedDiscount');
        this.setError(this.dataset.invalidText);
        this.input.focus();
        return;
      }
      if (code) localStorage.setItem('storedDiscount', code);
      else localStorage.removeItem('storedDiscount');
      this.setError('');
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
      if (document.body.classList.contains('template-cart')) window.sharedFunctions?.updateCart?.(cart);
      else window.sharedFunctions?.updateSidebarCart?.(cart);
    } catch (error) {
      this.setError(this.dataset.errorText);
    } finally {
      this.button?.classList.remove('is-loading');
      this.button?.removeAttribute('aria-busy');
    }
  }

  // The field's error line, as ui-field draws it.
  setError(message) {
    const field = this.input.closest('.ui-field');
    const errorId = `${this.input.id}-error`;
    let error = field.querySelector('.ui-field__error');
    field.classList.toggle('ui-field--invalid', Boolean(message));
    if (message) this.input.setAttribute('aria-invalid', 'true');
    else this.input.removeAttribute('aria-invalid');
    const describedBy = (this.input.getAttribute('aria-describedby') || '').split(' ').filter((id) => id && id !== errorId);
    if (!message) {
      error?.remove();
      this.input.setAttribute('aria-describedby', describedBy.join(' '));
      return;
    }
    if (!error) {
      error = document.createElement('p');
      error.className = 'ui-field__error';
      error.id = errorId;
      error.setAttribute('role', 'alert');
      field.append(error);
    }
    error.innerHTML = this.querySelector('template[data-error-icon]')?.innerHTML.trim() || '';
    error.append(message);
    this.input.setAttribute('aria-describedby', [...describedBy, errorId].join(' '));
  }
}

customElements.define('coupon-code', CouponCode);